<template>
  <div class="about-us">
    <LinkTitle title="titles.aboutUs" />
    <div class="content">
      <div class="left-side">
        <div class="left-title">
          <!-- {{ $t(aboutUsData.titlePrefix)
          }}<span>
            {{ $t(aboutUsData.highlightText) }}</span
          >{{ $t(aboutUsData.titleSuffix) }} -->
          <div class="leadership">{{ $t(aboutUsData.leadershipText) }}</div>
        </div>

        <div class="company-info">
          <ul class="data-points">
            <li v-for="(item, index) in aboutUsData.dataPoints" :key="index">
              <div class="company-content">
                <span>{{ item.value }}</span>
                <div class="icon">
                  <img width="100%" :src="item.icon" alt="" />
                </div>
              </div>
              <p>{{ $t(item.label) }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="right-side">
        <p v-html="$t(aboutUsData.description)"></p>
        <div class="right-img">
          <img
            width="100%"
            height="100%"
            :src="isMobile ? aboutUsData.mobileImageSrc : aboutUsData.imageSrc"
            :alt="$t(aboutUsData.imageAlt)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LinkTitle from "@/components/LinkTitle.vue";
export default {
  components: {
    LinkTitle,
  },
  data() {
    return {
      isMobile: false,
      aboutUsData: {
        titlePrefix: "aboutUs.titlePrefix",
        highlightText: "aboutUs.highlightText",
        titleSuffix: "aboutUs.titleSuffix",
        leadershipText: "aboutUs.leadershipText",
        dataPoints: [
          {
            value: "2024",
            label: "aboutUs.dataPoints.foundingYear",
            icon: require("@/assets/Home/创始.png"),
          },
          {
            value: "10000+",
            label: "aboutUs.dataPoints.customers",
            icon: require("@/assets/Home/服务.png"),
          },
          {
            value: "50+",
            label: "aboutUs.dataPoints.partners",
            icon: require("@/assets/Home/合作.png"),
          },
        ],
        description: "aboutUs.description",
        imageSrc: require("@/assets/index/7.jpg"),
        imageAlt: "aboutUs.imageAlt",
        mobileImageSrc: require("@/assets/index/7.jpg"),
      },
    };
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 940;
    },
  },
  mounted() {
    this.checkIsMobile();
  },
};
</script>

<style lang="less" scoped>
.content {
    width: 100%;
  display: flex;
  letter-spacing: 0.1vw;
}

.left-side {
  flex-shrink: 0;
  width: 13vw;
}

.left-side h2 {
  font-size: 1vw;
  text-align: center;
}

.left-side h2 span {
  font-size: 1.5vw;
  padding: 0 10px;
}

.left-side .leadership {
  font-size: 1.2vw;
  text-align: end;
  padding: 1.2vw 0;
}

.data-points {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 10vw;
  gap: 1.6vw;
}

.data-points li {
  margin-bottom: 15px;
  padding: 1vw;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.5);
  width: 100%;
  transition: transform 0.3s ease;
}

.data-points li:hover {
  transform: translateY(-5px);
}

.data-points li p {
  font-size: 0.8vw;
}

.data-points li .icon {
  width: 2vw;
  height: 2vw;
}

.company-info {
  padding: 0 12vw 0 0;
}

.company-content {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0.78vw 0;
}

.data-points li:nth-child(even) {
  margin-left: 30%;
}

.data-points li:nth-child(odd) {
  text-align: center;
}

.data-points span {
  font-size: 1.8vw;
  font-weight: bold;
}

.right-side {
  display: flex;
  flex-direction: column;
  padding-left: 4.95vw;
}

.right-side p {
  font-size: 1vw;
  line-height: 2vw;
}

.right-img {
  width: 49vw;
  height: 26vw;
}

.right-img img {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 940px) {
  .content {
    display: flex;
    letter-spacing: 0.1vw;

    .left-side {
      flex-shrink: 2;
      width: 11vw;
      display: none;
      h2 {
        font-size: 2vw;
        text-align: center;

        span {
          font-size: 2.5vw;
          padding: 0 10px;
        }
      }

      .leadership {
        font-size: 1.2vw;
        text-align: end;
        padding: 1.2vw 0;
      }
    }

    .data-points {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 10vw;
      gap: 1.5vw;

      li {
        margin-bottom: 1rem;
        padding: 0.2rem;
        border: 1px solid #eee;
        border-radius: 8px;
        box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.5);
        width: 100%;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        &:nth-child(even) {
          margin-left: 30%;
        }

        &:nth-child(odd) {
          text-align: center;
        }

        p {
          font-size: 2vw;
        }

        .icon {
          width: 3vw;
          height: 3vw;
        }

        span {
          font-size: 1.8vw;
          font-weight: bold;
        }
      }
    }

    .company-info {
      padding: 0 12vw 0 0;

      .company-content {
        display: flex;
        justify-content: space-between;
        padding: 0 0 0.78vw 0;
      }
    }
    .right-side {
      display: flex;
      flex-direction: column;
      padding-left: 5vw;
      width: 100%;
      p {
        text-indent: 2em;
        line-height: 2em;
        border-radius: 0.3vw;
        font-size: 2vw;
        letter-spacing: 0.1vw;
        font-weight: bold;
      }

      .right-img {
        width: 100%;
        height: auto;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>